import { faCircle, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ConfidenceLevelObject } from '@/types';

interface ConfidenceChipProps {
  confidenceLevel: ConfidenceLevelObject;
  onClick: () => void;
}

const ConfidenceChip = ({ confidenceLevel, onClick }: ConfidenceChipProps) => {
  return (
    <div
      onClick={onClick}
      className={`relative hover:cursor-pointer ${confidenceLevel.backgroundColor} rounded-md border px-3 py-2 text-xs ${confidenceLevel.borderColor} flex items-center gap-2`}
    >
      <p>
        <span>Confidence:</span> <b className={confidenceLevel.textColor}>{confidenceLevel.text}</b>
      </p>
      <FontAwesomeIcon
        icon={faInfoCircle}
        className="absolute top-[-8px] right-[-16px] mr-2 ml-2 cursor-pointer rounded-full text-sm text-blue-500 hover:text-blue-800"
      />
    </div>
  );
};

export default ConfidenceChip;
